// Classes.
import { BaseLocator } from './../locators/base.locator';
import { AthleteLocatorComponent } from './../locators/athlete.locator-component';


export class AthleteLocator extends BaseLocator {

  public athlete: AthleteLocatorComponent;

  constructor() {
    super('athlete');
    this.addComponentByType('athlete');
  }
}

